module.exports = [
  {
    id: 'mda_template',
    chapters: [
      {
        title: 'overview',
        content: ''
      }, {
        title: 'return_to_activity_timeline',
        content: ''
      }, {
        title: 'recovery_expectations',
        content: '',
        chapters: [
          {
            title: 'what_to_consider',
            content: ''
          }, {
            title: 'returning_to_activity',
            chapters: [
              {
                title: 'what_to_do',
                content: ''
              }, {
                title: 'what_to_avoid',
                content: ''
              }, {
                title: 'what_to_adjust',
                content: ''
              }
            ]
          }
        ]
      }, {
        title: 'checklist_for_healing',
        content: ''
      }
    ]
  }
];
